import React from 'react';
import WhyChoose from '../../common/WhyChoose';
import whyChooseImage from '../../../assets/images/about/why-we-exist.webp';

const Why = () => {
  const whyChooseData = {
    title: "Why Choose SimFinance?",
    description: "The financial space in Ghana is growing rapidly – but so is the complexity. What should be a simple decision can quickly become overwhelming, especially when you're not sure who to trust or what questions to ask. We believe everyone deserves access to honest, clear, and personalized financial guidance – not just the wealthy or well-connected.",
    listTitle: "Our platform simplifies the complexity by:",
    features: [
      "Presenting side-by-side comparisons of financial products",
      "Offering neutral, transparent insights (no hidden promotions or tricks)",
      "Delivering information in plain language – no jargon, no stress",
      "Ensuring every choice is rooted in your goals, not someone else's agenda"
    ],
    image: whyChooseImage
  };

  return <WhyChoose {...whyChooseData} />;
};

export default Why;